<template>
  <div>
    <HeaderNav></HeaderNav>
    <router-view></router-view>
    <footer class="float-start w-100 footer-total-01">
      <div class="main-footer01 d-inline-block w-100 py-5">
        <div class="container">
          <FooterNav></FooterNav>
          <hr class="mt-5" />
          <FooterText></FooterText>
        </div>
      </div>
    </footer>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import HeaderNav from "../../components/Header";
import FooterNav from "../../components/FooterNav";
import FooterText from "../../components/FooterText";
import api from "@/api";
// import util from "@/utils/utils";
// import { Loading } from 'element-ui';

export default {
  name: "",
  components: {
    HeaderNav,
    FooterNav,
    FooterText,
  },
  props: {},
  data() {
    return {
      login: api.get_session,
      user_account_key: "user_account",
    };
  },
  computed: {},
  watch: {},
  created() {
    const session = this.$route.query?.session;
    if (session) {
      localStorage.setItem("sessionKey", session);
      // this.$router.push("/");
      this.$router.replace('/')
    }
    // const account = this.$route.query?.account;
    // const pwd = this.$route.query?.pwd;
    // console.log("登录", account, pwd);
    // if (account) {
    //   const loadingInstance = Loading.service({ fullscreen: true });
    //   this.login({ account, pwd })
    //     .then((res) => {
    //       if (res.success) {
    //         localStorage.setItem("temp_login", JSON.stringify(res));
    //         localStorage.setItem(this.user_account_key, account);
    //         this.$router.push("/");
    //       } else {
    //         var msgs = util.getMsgs(res);
    //         var errmsg = msgs.join(",");
    //         this.$message.error("登录失败：" + errmsg);
    //       }
    //       // this.loading = false;
    //       loadingInstance.close();
    //     })
    //     .catch((e) => {
    //       this.$message.error("登录出错：" + e.toString());
    //       // this.loading = false;
    //       loadingInstance.close();
    //     });
    // }
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
// .mainBox {
//   margin-top: -100px;
// }
</style>

<style scoped>
/* @import '../../../public/static/static/css/bootstrap.min.css'; */
/* @import '../../../public/static/static/css/font-awesome.min.css'; */
/* @import '../../../public/static/static/css/all.min.css'; */
/* @import '../../../public/static/static/css/css2.css'; */
/* @import '../../../public/static/static/css/owl.carousel.min.css'; */
/* @import '../../../public/static/static/css/owl.theme.default.min.css'; */
/* @import '../../../public/static/static/css/style.min.css'; */
/* @import '../../../public/static/static/css/themify-icons.css'; */
/* @import url(https://fonts.googleapis.com/); */
/* @import url(https://fonts.gstatic.com/); */
</style>
